var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-container" },
    [
      _c("header", { staticClass: "page-header" }, [
        _c(
          "div",
          { staticClass: "d-flex align-items-center" },
          [
            _c("portal-target", {
              staticClass: "d-flex align-items-center mt-1",
              attrs: { name: "sidebar-toggle" }
            }),
            _vm._v(" "),
            _c("h4", { staticClass: "mb-0" }, [_vm._v(_vm._s(_vm.title))])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex align-items-center" },
          [
            _vm.canEdit
              ? _c(
                  "b-btn",
                  {
                    staticClass: "custom-btn-primary",
                    attrs: { disabled: _vm.isBusy },
                    on: {
                      click: function($event) {
                        return _vm.onCreate()
                      }
                    }
                  },
                  [
                    _vm.isBusy
                      ? _c("b-spinner", { attrs: { small: "" } })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("v-icon", { attrs: { name: "buttons/plus", size: 12 } }),
                    _vm._v("\n        " + _vm._s(_vm.createText) + "\n      ")
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "page-body" },
        [
          _c(
            "div",
            { staticClass: "page-filters" },
            [
              _c("filters-drawer", {
                attrs: {
                  query: _vm.filters.query,
                  "is-busy": _vm.isBusy,
                  "hide-search-button": ""
                },
                on: {
                  "update:query": function($event) {
                    return _vm.$set(_vm.filters, "query", $event)
                  },
                  submit: _vm.onSearch
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.isBusy || (_vm.items && _vm.items.length > 0)
            ? [
                _c(
                  "div",
                  { staticClass: "page-table-container" },
                  [
                    _c("b-table", {
                      ref: "data_table",
                      staticClass: "custom-table mb-0 text-small",
                      attrs: {
                        id: "catalogs_tables",
                        "sticky-header": "",
                        selectable: "",
                        "select-mode": "single",
                        responsive: "",
                        busy: _vm.isBusy,
                        items: _vm.items,
                        fields: _vm.fields,
                        "no-provider-filtering": "",
                        "no-provider-paging": "",
                        "no-provider-sorting": "",
                        "no-local-sorting": ""
                      },
                      on: {
                        "sort-changed": _vm.sortChanged,
                        "row-dblclicked": _vm.onRowClicked
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "table-busy",
                            fn: function() {
                              return [
                                _c("tables-skeleton", {
                                  attrs: { fields: _vm.fields, rows: 6 }
                                })
                              ]
                            },
                            proxy: true
                          },
                          {
                            key: "cell(name)",
                            fn: function(row) {
                              return [
                                _vm._t(
                                  "name-tag",
                                  function() {
                                    return [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(row.item.name) +
                                          "\n            "
                                      )
                                    ]
                                  },
                                  { item: row.item }
                                )
                              ]
                            }
                          },
                          {
                            key: "cell(active)",
                            fn: function(row) {
                              return [
                                !row.item.active
                                  ? _c("v-icon", {
                                      attrs: { name: "buttons/cross", size: 13 }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                row.item.active
                                  ? _c("v-icon", {
                                      attrs: { name: "buttons/check", size: 14 }
                                    })
                                  : _vm._e()
                              ]
                            }
                          },
                          {
                            key: "cell(action)",
                            fn: function(row) {
                              return [
                                _vm.canEdit
                                  ? _c(
                                      "b-btn",
                                      {
                                        staticClass: "text-dark",
                                        attrs: { variant: "link" },
                                        on: {
                                          click: function($event) {
                                            return _vm.onEdit(row.item)
                                          }
                                        }
                                      },
                                      [
                                        _c("v-icon", {
                                          attrs: {
                                            name: "buttons/edit",
                                            size: 15
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _c(
                                      "b-btn",
                                      {
                                        staticClass: "text-dark",
                                        attrs: { variant: "link" },
                                        on: {
                                          click: function($event) {
                                            return _vm.onView(row.item)
                                          }
                                        }
                                      },
                                      [
                                        _c("v-icon", {
                                          attrs: {
                                            name: "buttons/eye",
                                            size: 15
                                          }
                                        })
                                      ],
                                      1
                                    )
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "page-pagination" },
                  [
                    _c("pagination-footer", {
                      attrs: {
                        "use-router": "",
                        "current-page": _vm.currentPage,
                        "total-rows": _vm.totalRows,
                        "per-page": _vm.perPage
                      },
                      on: {
                        "update:currentPage": function($event) {
                          _vm.currentPage = $event
                        },
                        "update:current-page": function($event) {
                          _vm.currentPage = $event
                        },
                        "update:perPage": function($event) {
                          _vm.perPage = $event
                        },
                        "update:per-page": function($event) {
                          _vm.perPage = $event
                        },
                        "page-click": _vm.onPagination,
                        "per-page-change": _vm.onPerPageChange
                      }
                    })
                  ],
                  1
                )
              ]
            : _c(
                "div",
                { staticClass: "empty-state-container" },
                [
                  _c("v-icon", {
                    attrs: { name: "navbar/empty_table", size: 90 }
                  }),
                  _vm._v(" "),
                  _c("h5", [
                    _vm._v(
                      _vm._s(
                        _vm.isFiltered
                          ? "Нет данных соответствующих фильтрам."
                          : "Нет созданных записей в каталоге."
                      )
                    )
                  ]),
                  _vm._v(" "),
                  !_vm.isFiltered
                    ? _c(
                        "div",
                        [
                          _c("p", [
                            _vm._v("Создайте новую запись прямо сейчас")
                          ]),
                          _vm._v(" "),
                          _vm.canEdit
                            ? _c(
                                "b-btn",
                                {
                                  staticClass: "custom-btn-primary mt-1",
                                  attrs: { disabled: _vm.isBusy },
                                  on: {
                                    click: function($event) {
                                      return _vm.onCreate()
                                    }
                                  }
                                },
                                [
                                  _c("v-icon", {
                                    staticClass: "mr-1",
                                    attrs: { name: "buttons/plus", size: 12 }
                                  }),
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(_vm.createText) +
                                      "\n        "
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
        ],
        2
      ),
      _vm._v(" "),
      _c("router-view", {
        key: _vm.$route.fullPath,
        on: { refresh: _vm.getItems, "modal-closed": _vm.onModalClosed }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6b9581e2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b9581e2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Catalogs/Catalogs.vue
// module id = null
// module chunks = 